<template>
  <div>
    <div class="supplier-stage-action-buttons">
      <div
          class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
          @click="runAutoBindSuppliers()"
          data-toggle="tooltip" data-placement="bottom"
          title="Próbuje powiązać niepowiązane dotychczas lokalne kartoteki dostawców z centralnymi kartotekami dostawców."
      >
        <i class="fas fa-sync-alt"/>
        Powiąż automatycznie
      </div>
    </div>
    <div class="drugstores-suppliers-stage">

      <div class="row">
        <SearchBar2
            :searchOptions="fieldsAvailableForSearch"
            @searchRequest="searchOnList($event)"
        />
      </div>

      <div class="row">
        <div class="form-group">
          <label for="showOnlyUnBound" style="margin-right:4px!important">Pokaż tylko niepowiązane</label>
          <input type="checkbox" id="showOnlyUnBound" v-model="showOnlyUnBound"/>
        </div>
      </div>


      <div class="drugstores-suppliers-table-container">
        <div>
          <CommonTable2
              :table="tableData"
              :rowIdentifier="rowIdentifierKey"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              :key="refreshTable"
              :currentPage="currentPage"
              :totalRows="commonModule.getRawDrugstoresSuppliersDataTotal"
              :totalPages="commonModule.getRawDrugstoresSuppliersPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              @onPageChange="currentPage = $event"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
              :stickyScrollbarBottom="0"
          />
        </div>


      </div>


    </div>
    <b-modal
        v-model="showLocalDrugstoresSuppliersModal"
        id="local-supplier-info-form-modal"
        scrollable
        :title="supplierDetailsModalTitle"
        title-class="font-18"
        hide-footer
        size="lg"
        style="z-index:99999!important;"
        @hide="currentSelectedLocalSupplierData = null"

    >
      <CommonObjectSimplePrintPage id="show-supplier-data-pdf" ref="show-supplier-data-pdf"
                                   :objectToPrint="currentSelectedLocalSupplierData || {}" title="Dostawca lokalny"/>
    </b-modal>

    <SupplierListModal
                       :showModal="showSelectCentralSupplierModal"
                       @update:showModal="showSelectCentralSupplierModal = $event"
                       title="Powiąż z centralną kartoteką dostawcy"
                       ok-title="Powiąż"
                       :multiselect="false" @onApply="runBindWithSupplier"
                       :showMassActions="false"
                       :showRowActions="false"
    />


  </div>

</template>


<script>
import CommonTable2 from "@/components/widgets/CommonTable2";
import {BModal} from "bootstrap-vue-next";
import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import {log} from "@/state/pinia/log";
import CommonObjectSimplePrintPage from "@/components/widgets/CommonObjectSimplePrintPage.vue";
import {suppliersHelperMethods} from "./helper/suppliersHelperMethods";
import SupplierListModal from "./SupplierListModal.vue";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";


export default {
  name: "DrugstoresSuppliersLocalDataList",
  props: {},
  components: {
    SupplierListModal,
    CommonObjectSimplePrintPage,
    BModal,
    SearchBar2,
    CommonTable2
  },
  data() {
    return {
      rowIdentifierKey: "data_row_id",
      tableData: {},
      currentPage: 1,
      sortingDirection: "ASC",
      sortingKey: "NAZWA_DOSTAWCY",
      searchRequest: {
        searchPhrase: null,
        searchKey: null,
      },
      localSuppliersRows: [],
      availableHeaders: [],
      tableMassActions: [
        {
          text: "Powiąż ręcznie z centralnym dostawcą",
          icon: "fas fa-link",
          action: "bind-with-central-supplier",
          class: "btn btn-success table-actions-button edit-button",
          enabled: true,
        },
        {
          text: "Powiąż automatycznie",
          icon: "fas fa-sync-alt",
          action: "create-bind-with-central-supplier",
          class: "btn btn-success table-actions-button edit-button",
          enabled: true,
        },
        {
          text: "Usuń powiązania",
          icon: "fas fa-link-slash",
          action: "remove-central-supplier-binding",
          class: "btn btn-warning table-actions-button edit-button",
          enabled: true,
        }
      ],
      rowActions: [
        {
          text: "",
          icon: "fas fa-window-maximize",
          action: "view-local-supplier-details",
          class: "btn btn-info table-actions-button edit-button",
          enabled: true,
          tooltip: "Zobacz szczególy dostawcy lokalnego w aptece",
        },


      ],
      suppliersVisibleHeaders: ["id_kamsoft_dost", "data_row_id", "id_apteki", "nazwa_dostawcy", "nip", "nazwa_kartoteki_centralnej_dostawcy"],
      drugstoresLocalSuppliersVisibleHeadersTitlesMap: {
        "id_kamsoft_dost": "IdKamsoft",
        "data_row_id": "IdLocal",
        "id_apteki": "Apteka",
        "nazwa_dostawcy": "Nazwa dostawcy",
        "nip": "NIP",
        "nazwa_kartoteki_centralnej_dostawcy": "Centralny dostawca"

      },
      fieldsAvailableForSearch: [],
      showOnlyUnBound: false,
      refreshTable: true, //added key to force re-rendering
      showLocalDrugstoresSuppliersModal: false,
      showSelectCentralSupplierModal: false,
      currentSelectedLocalSupplierData: null,
      supplierDetailsModalTitle: "Dane dostawcy lokalnego",
      localIdsSelected: [],
      selectedCentralSupplierGuidToBind: null,
      bindSupplierTitleMessage: "Wybierz centralnego dostawcę do powiązania z dostawcą lokalnym:",

    };
  },
  computed: {
        simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {

    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.refreshLocalSuppliersData();
    },
    runAction(event) {
      log.log(event)
      if (event.action.action === "view-local-supplier-details") {
        suppliersHelperMethods.showLocalSupplierDetails(event.itemData, this.rowIdentifierKey, this.localSuppliersRows).then((responsePayload) => {
          this.supplierDetailsModalTitle = responsePayload.supplierDetailsModalTitle;
          this.showLocalDrugstoresSuppliersModal = responsePayload.showLocalDrugstoresSuppliersModal;
          this.currentSelectedLocalSupplierData = responsePayload.currentSelectedLocalSupplierData;
        });

      } else if (event.action.action === "remove-central-supplier-binding") {
        suppliersHelperMethods.unBindCentralSupplier([event.itemData[this.rowIdentifierKey]], this.rowIdentifierKey, this.localSuppliersRows).then((responsePayload) => {
          if (responsePayload.isConfirmed) {
            this.refreshLocalSuppliersData();

          }
        });

      } else if (event.action.action === "bind-with-central-supplier") {
        this.selectedCentralSupplierGuidToBind = null;
        suppliersHelperMethods.bindWithCentralSupplier(event.itemData, this.rowIdentifierKey, this.localSuppliersRows).then((responsePayload) => {


          this.showSelectCentralSupplierModal = responsePayload.showSelectCentralSupplierModal;
          this.currentSelectedLocalSupplierData = responsePayload.currentSelectedLocalSupplierData;
        });

      } else if (event.action.action === "create-bind-with-central-supplier") {
        suppliersHelperMethods.createAndBindSuppliers([event.itemData[this.rowIdentifierKey]]).then(() => {
          this.currentSelectedLocalSupplierData = null;
          this.selectedCentralSupplierGuidToBind = null;

        });
      } else {
        suppliersHelperMethods.showNoSupplierDataWarning(event.itemData[this.rowIdentifierKey])
      }

    },

    refreshLocalSuppliersData() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie danych o dostawcach lokalnych w aptekach.");
      return this.commonModule.httpGetRawDrugstoresSuppliersHeaders().then(() => {
        this.refreshTable = false;
        return suppliersHelperMethods.refreshLocalSuppliersList(this.rowActions,this.drugstoresLocalSuppliersVisibleHeadersTitlesMap,this.suppliersVisibleHeaders,this.currentPage,this.sortingKey,
            this.sortingDirection,this.searchRequest,this.showOnlyUnBound,null).then((responsePayload) => {
          this.availableHeaders = responsePayload.availableHeaders;
          this.localSupplierHeaders = responsePayload.localSupplierHeaders;
          this.localSuppliersRows = responsePayload.localSuppliersRows;
          this.tableData = {
            headers: this.localSupplierHeaders,
            data: this.localSuppliersRows,
            massActions: this.tableMassActions
          }

        }).then(() => {
          this.refreshTable = true;
          suppliersHelperMethods.refreshFieldsAvailableForSearch(this.availableHeaders,this.drugstoresLocalSuppliersVisibleHeadersTitlesMap).then((responsePayload) => {
            this.fieldsAvailableForSearch = responsePayload.fieldsAvailableForSearch;
          });
        });
      });
    },

    runAutoBindSuppliers(){
      suppliersHelperMethods.autoBindSuppliers()
    },

    runBindWithSupplier(suppliers){
      if (suppliers== null || suppliers.length === 0) {
        return;
      }

      this.selectedCentralSupplierGuidToBind = suppliers[0].guid;


      suppliersHelperMethods.bindWithSupplier(this.localIdsSelected,this.rowIdentifierKey,this.currentSelectedLocalSupplierData,this.selectedCentralSupplierGuidToBind);
      this.currentSelectedLocalSupplierData = null;
      this.selectedCentralSupplierGuidToBind = null;
      this.showSelectCentralSupplierModal = false;
    },

    runMassAction(event) {
      log.log(event);
      if (event.action.action === "bind-with-central-supplier") {
        suppliersHelperMethods.showBindWithCentralSupplierModal(event.items, this.rowIdentifierKey, this.localSuppliersRows).then((result) => {
          this.showSelectCentralSupplierModal = result.showSelectCentralSupplierModal;

        });

      } else if (event.action.action === "remove-central-supplier-binding") {
        suppliersHelperMethods.unBindCentralSupplier(event.items, this.rowIdentifierKey, this.localSuppliersRows).then((responsePayload) => {
          if (responsePayload.isConfirmed) {
            this.refreshLocalSuppliersData();
          }
        });
      } else if (event.action.action === "create-bind-with-central-supplier") {
        suppliersHelperMethods.createAndBindSuppliers(event.items).then(() => {
          this.currentSelectedLocalSupplierData = null;
          this.selectedCentralSupplierGuidToBind = null;

        });
      }
    },

    sort(sortKey) {
      log.log(sortKey);
      this.sortingKey = sortKey;
      this.refreshLocalSuppliersData();
      this.toggleSortingDirection();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    checkAction(event) {
      this.localIdsSelected = event.items
    },


  },
  watch: {
    currentPage: {
      handler() {
        this.refreshLocalSuppliersData();
      },
      deep: true,
    },

    showOnlyUnBound: {
      handler() {
        this.refreshLocalSuppliersData();
      },
      deep: true,
    },


  },
  mounted() {

  },
  created() {
    this.refreshLocalSuppliersData();



  },
};
</script>

<style scoped>
.drugstores-suppliers-stage {
  margin-left: 16px;
  margin-right: 16px;
}

.drugstores-suppliers-table-container {
}

.drugstores-suppliers-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.table-success {
  background-color: #d4edda;
  color: #155724;
}


.table-info {
  background-color: #d4edda;
  color: #152c57;
}

.table-warning {
  background-color: #fff3cd;
  color: #856404;
}

.table-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.supplier-stage-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}


</style>
